import { Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import { Account } from 'dashboard/models/account';
import { Case } from 'dashboard/models/case';
import { CaseQueue } from 'dashboard/models/case-queue';
import { AttributeColumn } from 'dashboard/models/table-view';
import { Tag } from 'dashboard/models/tag';
import { User } from 'dashboard/models/user';
import {
  columnDataMapping,
  columnLabelMapping,
} from 'dashboard/views/DashboardCasesView/ConfigurableCasesTable';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';

const TableBodyZeroState = styled('div')`
  margin-top: ${Spacing[2]};
  padding: ${Spacing[7]} ${Spacing[2]};
  background-color: ${({ theme }) => theme.color.background.secondary};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  text-align: center;
  font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
`;

const TableCellStyled = styled(TableCell)`
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export interface DashboardHomeCasesTableProps {
  accounts: Account[];
  cases: Case[];
  caseCaseQueues: CaseQueue[];
  caseUsers: User[];
  tags: Tag[];
  columnOrdering: AttributeColumn[];
}

// TODO: CAS-86 [chris] This table is extremely tightly coupled with dashboard/views/ConfigurableCasesTable.
// Ideally, DashboardHomeCasesTable would wrap around a more general ConfigurableTable component instead of
// copying the code from dashboard/views/ConfigurableCasesTable.
export const DashboardHomeCasesTable = ({
  accounts,
  cases,
  caseCaseQueues,
  caseUsers,
  tags,
  columnOrdering,
}: DashboardHomeCasesTableProps) => {
  return (
    <>
      <Table data-test='dashboard-home__cases-table'>
        <TableHead>
          <TableRow>
            {columnOrdering.map((column) => (
              <TableHeaderCell
                key={`case-header__${column.key}`}
                data-test={`dashboard-home__cases-table__${column.key}-header`}
              >
                {columnLabelMapping(column)}
              </TableHeaderCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {cases.map((kase) => {
            return (
              <TableRow
                key={`case-${kase.id}`}
                data-test={`case-${kase.id}`}
                as={Link}
                to={`/dashboard/cases/${kase.id}`}
              >
                {columnOrdering.map((column) => {
                  return (
                    <TableCellStyled
                      key={`case-${kase.id}__${column.key}`}
                      data-test={`case-${kase.id}__${column.key}`}
                    >
                      {columnDataMapping(
                        kase,
                        column.key,
                        accounts,
                        caseCaseQueues,
                        caseUsers,
                        tags,
                      )}
                    </TableCellStyled>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {cases.length === 0 && (
        <TableBodyZeroState data-test='dashboard-home__cases-table__zero-state'>
          No Cases created in the past month are assigned to you.
        </TableBodyZeroState>
      )}
    </>
  );
};

export default DashboardHomeCasesTable;
